import { useMutation } from '@tanstack/react-query';

import { useAuthStore } from '../../stores/authStore';
import { removeAuthFromUrl } from '../../utils/auth';
import { client } from '../client';

export type RequestAccessPayload = { email: string; loginToken: string };

const getAccessToken = async (payload: RequestAccessPayload) => {
  const res = await client.post<{ jwt: { accessToken: string } }>('v1/auth/create-session', payload);

  return res.data;
};

export const useGetAccessToken = () => {
  const setAccessToken = useAuthStore((state) => state.setAccessToken);
  const setIsAuthComplete = useAuthStore((state) => state.setIsAuthComplete);
  return useMutation({
    mutationFn: (payload: RequestAccessPayload) => getAccessToken(payload),
    onSuccess: (res) => {
      setAccessToken(res.jwt.accessToken);
    },
    onSettled: () => {
      removeAuthFromUrl();
      setIsAuthComplete(true);
    },
    onError: () => {
      setAccessToken(null);
    },
  });
};
